<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="px-4">
        <v-row class="px-4 my-4">
          <v-btn color="primary" depressed @click="goBack()">
            <v-icon> mdi-chevron-left </v-icon>
          </v-btn>
          <div class="text-h5 text-sm-h4 pl-4">{{ goBackMessage }}</div>
        </v-row>
        <substance-card-info :substanceItem="substance"></substance-card-info>
        <v-card class="my-4">
          <v-container fluid>
            <v-row class="my-2 mx-2">
              <v-col>
                <v-row>
                  <h1 class="text-h6 text-sm-h4">
                    {{ $t("showSubstance.values.title") }} :
                  </h1>
                </v-row>
                <v-row class="pt-4">
                  <v-col cols="12" sm="4" class="ma-0 pa-0">
                    <rules-panel
                      :items="rulesbytheme"
                      v-model="activeRuleId"
                    ></rules-panel>
                  </v-col>
                  <v-col cols="12" sm="8" class="pa-4">
                    <v-row class="py-2 px-4">
                      <table-value
                        :headers="activesValues.header"
                        :substances="activesValues.transfertData"
                        :massiveValues="massiveValues"
                      >
                        <v-btn
                          depressed
                          color="primary"
                          @click="seeRule(activeRuleId)"
                          class="mx-2"
                        >
                          {{ $t("showSubstance.seeRule") }}
                        </v-btn>
                        <v-btn
                          depressed
                          color="secondary"
                          @click="exportResult()"
                          class="mx-2"
                        >
                          {{ $t("searchSubstance.Export") }}
                        </v-btn>
                      </table-value>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import RulesPanel from "../components/RulesPanel.vue";
import SubstanceCardInfo from "../components/SubstanceCardInfo.vue";
import TableValue from "../components/TableValue.vue";
import { monitore } from "../components/helpers/helpers";

export default {
  data() {
    return {
      id: "",
      substance: {},
      rulesbytheme: [],
      activeRuleId: {},
      activesValues: {
        header: [],
        transfertData: [],
      },
      massiveValues: [],
      fav: false,
    };
  },
  computed: {
    ...mapGetters(["lastPage", "currentPage"]),
    goBackMessage() {
      let message = this.$t("showSubstance.goBack.back");
      if (this.lastPage.name === "Favorites") {
        message = this.$t("showSubstance.goBack.fav");
      } else if (
        this.lastPage.name === "SearchSubstances" ||
        this.lastPage.name === "SearchMultiRulesResult"
      ) {
        message = this.$t("showSubstance.goBack.search");
      }
      return message;
    },
  },
  components: {
    RulesPanel,
    SubstanceCardInfo,
    TableValue,
  },
  beforeMount() {
    this.id = "";
    if (this.lastPage.name === this.$route.name) {
      this.id = this.lastPage.params.id;
      if (this.lastPage.params.lastPage) {
        this.setLastPage({
          name: this.lastPage.params.lastPage.name,
          params: this.lastPage.params.lastPage.params,
        });
      }
    } else if (this.$route.params.id) {
      this.id = this.$route.params.id;
    } else if (this.currentPage.name === this.$route.name) {
      this.id = this.currentPage.params.id;
    }
    this.getSubstance(this.id);
  },
  watch: {
    activeRuleId(val) {
      let params = { id: this.id, rule: val, theme: "" };
      this.substance.rules.forEach((rule) => {
        if (val.id === rule.id) {
          this.resetActivesValues();
          let data = {};
          this.massiveValues = [];
          for (const [key, value] of Object.entries(rule)) {
            if (key !== "id") {
              if (value !== null && value.length > 200) {
                if (this.massiveValues.indexOf(key) < 0) {
                  this.massiveValues.push(key);
                }
              }

              let label = key;
              if (key == 'name') {
                label = 'Nom dans le texte'
              }

              this.activesValues.header.push({
                text: label,
                value: key,
                align: "start",
                sortable: false,
              });

              data[key] = value;
            }
          }
          this.activesValues.transfertData.push(data);
        }
      });
      this.rulesbytheme.forEach((theme) => {
        theme.children.forEach((rule) => {
          if (rule.id === val.id) {
            params.theme = theme.name;
          }
        });
      });
      this.setCurrentPage({
        name: this.$route.name,
        params: params,
      });
    },
  },
  methods: {
    ...mapMutations([
      "setLastPage",
      "setCurrentPage",
      "setMultiRulesSelection",
    ]),
    async getSubstance(id) {
      let url = "/substances/" + id;
      var request = { method: "GET", url: url };
      try {
        var response = await this.axios(request);
        monitore("Show substance", id);
        this.substance = response.data.substance;
        this.substance["synonymes"] = response.data.synonymes;
        this.rulesbytheme = response.data.rulesbytheme;
        if (this.$route.params.rule) {
          this.activeRuleId = this.$route.params.rule;
        } else if (this.currentPage.name === this.$route.name) {
          if (this.currentPage.params.rule) {
            this.activeRuleId = this.currentPage.params.rule;
          } else {
            this.setCurrentPage({
              name: this.$route.name,
              params: { id: this.id },
            });
          }
        } else {
          this.setCurrentPage({
            name: this.$route.name,
            params: { id: this.id },
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    resetActivesValues() {
      this.activesValues.header = [];
      this.activesValues.transfertData = [];
    },
    goBack() {
      this.$router.push(this.lastPage);
    },
    async exportResult() {
      this.setMultiRulesSelection(this.activeRuleId.id);
      let substancesToExport = [
        {
          substance: {
            cas: this.substance.cas,
            ce: this.substance.ce,
            name: this.substance.usual_name,
            id: this.substance._id,
          },
          rulesNames: [],
        },
      ];
      this.rulesbytheme.forEach((theme) => {
        theme.children.forEach((rule) => {
          substancesToExport[0].rulesNames.push(rule.name);
        });
      });
      let lP = this.lastPage;
      this.setLastPage({
        name: this.$route.name,
        params: {
          id: this.substance._id,
          lastPage: lP,
        },
      });
      this.$router.push({
        name: "Export",
        params: { substances: substancesToExport },
      });
    },
    seeRule(rule) {
      let lP = this.lastPage;
      this.setLastPage({
        name: this.$route.name,
        params: {
          id: this.substance._id,
          lastPage: lP,
        },
      });
      this.$router.push({
        name: "SearchRules",
        params: {
          rule: rule,
          theme: this.currentPage.params.theme,
        },
      });
    },
  },
};
</script>
